"use client"
import ResultRow, {ResultRowSkeleton} from "@/app/components/auctor/result/ResultRow"
import {IAppliedFilter, ITemplateConfig} from "@/app/models/auctor"
import dynamic from "next/dynamic"
import {useState} from "react"

const AppIcon = dynamic(() => import("@/app/components/atomic/AppIcon"))

const RESULTS_TRUNCATE_LIMIT = 10

export default function ResultList({
                                       templateConfig,
                                       appliedFilters,
                                       featuredResults,
                                       results,
                                       isPreview,
                                       isHidden,
                                   }: {
    templateConfig: ITemplateConfig
    appliedFilters: IAppliedFilter[]
    featuredResults: any[]
    results: any[]
    isPreview?: boolean
    isHidden?: boolean
}) {
    const [showMore, setShowMore] = useState(false)

    const safeFeaturedResults = Array.isArray(featuredResults) ? featuredResults : []
    const safeResults = Array.isArray(results) ? results : []

    const featuredResultsToShow = showMore ? safeFeaturedResults : safeFeaturedResults.slice(0, RESULTS_TRUNCATE_LIMIT)
    const resultsToShow = showMore ? safeResults : safeResults.slice(0, RESULTS_TRUNCATE_LIMIT)

    const atLeastOneColumnHasLabel = templateConfig?.column_configs?.some((column: any) => column.label)

    return (
        <div
            className={`flex-col items-center w-full -mb-8 ${isHidden ? 'hidden' : 'flex'}`}
            data-test="comparator-results"
        >
            <table className={'border-separate border-spacing-y-4 -translate-y-4 w-full'}>
                {atLeastOneColumnHasLabel && (
                    <thead className="rounded p-4 font-semibold hidden md:table-row-group w-full bg-rm-gray-light/20 text-pale">
                        <tr className="table-row-header w-full">
                            {templateConfig.column_configs.map((column: any, idx: number) => (
                                <th
                                    key={"column-" + idx}
                                    className={`px-2 py-8 w-${column.col_span}/12 border-y border-r first:border-l border-rm-gray-light
                                    ${idx === 0 ? "rounded-l-xl" : ""}
                                    ${idx === templateConfig.column_configs.length - 1 ? "rounded-r-xl" : ""}
                               `}
                                >
                                    {column.label}
                                </th>
                            ))}
                            <th className="absolute hidden"></th>
                        </tr>
                    </thead>
                )}

                <tbody>
                    {featuredResultsToShow.map((resultRow: any, idx: number) => (
                        <ResultRow
                            isPreview={isPreview}
                            key={"featured-result-" + idx}
                            templateConfig={templateConfig}
                            appliedFilters={appliedFilters}
                            resultRow={resultRow}
                            isFeatured={idx === 0}
                        />
                    ))}

                    {resultsToShow.map((resultRow: any, idx: number) => (
                        <ResultRow
                            isPreview={isPreview}
                            key={"regular-result-" + idx}
                            templateConfig={templateConfig}
                            appliedFilters={appliedFilters}
                            resultRow={resultRow}
                            isFeatured={safeFeaturedResults.length === 0 && idx === 0}
                        />
                    ))}
                </tbody>
            </table>

            {(safeResults.length > RESULTS_TRUNCATE_LIMIT || safeFeaturedResults.length > RESULTS_TRUNCATE_LIMIT) && (
                <button
                    className="p-2 bg-blue-100 font-semibold border border-blue-300 rounded
                            hover:border-blue-400 hover:bg-blue-400 transition-all duration-300 text-blue-700"
                    onClick={() => setShowMore(!showMore)}
                >
                    {showMore && (
                        <>
                            <AppIcon type="duotone" iconClassName="fa-chevron-up" className="mr-2"/>
                            Afficher moins
                        </>
                    )}
                    {!showMore && (
                        <>
                            <AppIcon type="duotone" iconClassName="fa-chevron-down" className="mr-2"/>
                            Afficher plus d&apos;offres
                        </>
                    )}
                </button>
            )}
        </div>
    )
}

export function ResultsSkeleton({count}: { count: number }) {
    return (
        <>
            <div className="flex flex-col items-center w-full gap-4">
                {Array.from(Array(count).keys()).map((idx: number) => (
                    <ResultRowSkeleton key={idx} withBanner={idx === 0}/>
                ))}
            </div>
        </>
    )
}
